export default __webpack_public_path__ + "static/media/Haus_Icon_cleanV3.1ccb1eb9.png";